<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">News Items</template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="created_at"
            direction="DESC"
            delete-label="title"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';

    export default {
        name: "Members",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'news-items',
                numberOfFilters: 1,
                pageActions: {},
                fields: [
                    {
                        name: 'Title',
                        column: 'title',
                        route: '/news-items/{id}/view',
                        linked: true,
                        sortCol: 'title'
                    },
                    {
                        name: 'Created By',
                        column: 'creator.full_name',
                    },
                    {
                        name: 'Created',
                        column: 'created_at',
                        date: true,
                        columnClass: 'whitespace-no-wrap',
                        format: 'DD/MM/YYYY',
                        width: 'w-24',
                        sortCol: 'created_at'
                    },
                    {
                        name: 'Members',
                        column: 'members',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    },
                    {
                        name: 'Public',
                        column: 'public',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'news-items.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'news-items.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New News Item',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/news-items/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('news-items.create') !== -1
                    }
                ],
                additional: []
            }
        },
        computed: {
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.news.search){
                    return filters.news.search.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
